import { __extends } from "tslib";
import { TraitInfo } from './TraitInfo';
var MethodTraitInfo = /** @class */ (function (_super) {
    __extends(MethodTraitInfo, _super);
    function MethodTraitInfo(abc, kind, multiname, methodInfo) {
        var _this = _super.call(this, abc, kind, multiname) || this;
        _this.abc = abc;
        _this.kind = kind;
        _this.multiname = multiname;
        _this.methodInfo = methodInfo;
        _this.method = null;
        return _this;
    }
    return MethodTraitInfo;
}(TraitInfo));
export { MethodTraitInfo };
